
import SvgIcon from "@mui/material/SvgIcon";

export const AnimationIcon = (props) => (
  <SvgIcon {...props}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#fff"
        strokeWidth="2"
        d="M22.5 20H1.5C1.10218 20 0.720644 19.842 0.43934 19.5607C0.158035 19.2794 0 18.8978 0 18.5L0 3.5C0 3.10218 0.158035 2.72064 0.43934 2.43934C0.720644 2.15804 1.10218 2 1.5 2H22.5C22.8978 2 23.2794 2.15804 23.5607 2.43934C23.842 2.72064 24 3.10218 24 3.5V18.5C24 18.8978 23.842 19.2794 23.5607 19.5607C23.2794 19.842 22.8978 20 22.5 20ZM1.5 3C1.36739 3 1.24021 3.05268 1.14645 3.14645C1.05268 3.24021 1 3.36739 1 3.5V18.5C1 18.6326 1.05268 18.7598 1.14645 18.8536C1.24021 18.9473 1.36739 19 1.5 19H22.5C22.6326 19 22.7598 18.9473 22.8536 18.8536C22.9473 18.7598 23 18.6326 23 18.5V3.5C23 3.36739 22.9473 3.24021 22.8536 3.14645C22.7598 3.05268 22.6326 3 22.5 3H1.5Z"></path>
      <path d="M22 21H2V22H22V21Z" fill="#D1D3D4"></path>
      <path d="M9.75 14.75C9.61739 14.75 9.49021 14.6973 9.39645 14.6035C9.30268 14.5098 9.25 14.3826 9.25 14.25V7.74999C9.24998 7.66177 9.2733 7.57512 9.3176 7.49883C9.36189 7.42253 9.42559 7.35932 9.50221 7.3156C9.57883 7.27188 9.66566 7.24921 9.75388 7.24989C9.8421 7.25058 9.92856 7.27459 10.0045 7.31949L15.5045 10.5695C15.5795 10.6137 15.6416 10.6766 15.6848 10.7522C15.7279 10.8277 15.7506 10.9132 15.7506 11.0002C15.7506 11.0873 15.7279 11.1728 15.6848 11.2483C15.6416 11.3238 15.5795 11.3868 15.5045 11.431L10.0045 14.681C9.92729 14.7262 9.83945 14.75 9.75 14.75ZM10.25 8.62649V13.3735L14.267 11L10.25 8.62649Z" fill="#D1D3D4"></path>
    </svg>
  </SvgIcon>
);






